import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-loader-hotel",
  templateUrl: "./loader-hotel.component.html",
  styleUrls: ["./loader-hotel.component.scss"],
})
export class LoaderHotelComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
